
const wordConfirmed = "Aprovado";
const wordPending = "Suspenso";
const wordInProgress = "Em Vigor";
const wordRejected = "Cancelado";

export const computeClass = (classValue) => ({
    confirmed: classValue || "active" === classValue,
    rejected: !classValue || "inactive" === classValue,

});

export const computeClassContract = (classValue) => ({
    confirmed: wordConfirmed === classValue,
    inProgress: wordInProgress === classValue,
    pending: wordPending === classValue,
    rejected: wordRejected === classValue,
});
